import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../../api/axiosConfig";
import _ from "lodash";
import * as idb from '../../../functions/databaseService/indexedDB';

// Action Types
export const FIREBASE_GET_LATEST_TASK_FILE_SUCCESS = "FIREBASE_GET_LATEST_TASK_FILE_SUCCESS";
export const FIREBASE_GET_LATEST_TASK_FILE_ERROR = "FIREBASE_GET_LATEST_TASK_FILE_ERROR";
export const SYNCHRONOUS_CHANGE_PARENT = "SYNCHRONOUS_CHANGE_PARENT"
export const SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY = "SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY";
export const SYNCHRONOUS_CHANGE_SIBLING_POSITION = "SYNCHRONOUS_CHANGE_SIBLING_POSITION";
export const SYNCHRONOUS_CHANGE_TODO_PRIORITY = "SYNCHRONOUS_CHANGE_TODO_PRIORITY";
export const SYNCHRONOUS_ORDER_SIBLINGS = "SYNCHRONOUS_ORDER_SIBLINGS";

// Thunk Action Creator
export const getLatestTaskList = createAsyncThunk(
    "api/Task/latestTaskList",
    async (_, { dispatch }) => {
        try {

            const online = navigator.onLine;
            if (online) {
                const response = await axios.put(

                    `${import.meta.env.VITE_PUBLIC_DOMAIN}Task/latestTaskList`,
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                );

                //Check for response 
                //Store API result into indexed DB
                if (response.status == 200) {
                    if (response.data === '') {
                        throw new Error("The last task has not been saved. Logging the user out");
                    } else {
                        idb.storeTaskList(response.data.tasks || response.data);
                    }
                }

                //Dispatch Indexed DB instead of Axios result
                dispatch({
                    type: FIREBASE_GET_LATEST_TASK_FILE_SUCCESS,
                    payload: response.data
                });
            }
            else {
                //get data from indexed DB
                const taskListData = await idb.getTasks();
                if (taskListData) {
                    //Dispatch Indexed DB instead of Axios result
                    dispatch({
                        type: FIREBASE_GET_LATEST_TASK_FILE_SUCCESS,
                        payload: taskListData
                    });
                }
                else {
                    console.log("No tasks found in IndexedDB");
                }
            }
        }
        catch (error) {
            dispatch({ type: FIREBASE_GET_LATEST_TASK_FILE_ERROR, payload: error });
        }
    }
);

export const changeGlobalPrioritySynchronously = (orderedChildren) => ({
    type: SYNCHRONOUS_CHANGE_GLOBAL_PRIORITY,
    payload: { orderedChildren },
});

export const changeTodoPrioritySynchronously = (priorityList) => ({
    type: SYNCHRONOUS_CHANGE_TODO_PRIORITY,
    payload: { priorityList },
});

export const changeParentSynchronously = (movedTaskId, destinationProjectId, sourceProjectId, nearestTaskId, destinationIndex) => ({
    type: SYNCHRONOUS_CHANGE_PARENT,
    payload: { movedTaskId, destinationProjectId, sourceProjectId, nearestTaskId, destinationIndex },
});

export const changeSiblingPositionSynchronously = (movedProjectId, newIndex) => ({
    type: SYNCHRONOUS_CHANGE_SIBLING_POSITION,
    payload: { movedProjectId, newIndex },
});
